import React from "react";

import Col from "antd/es/col";
import { Row } from "antd/es/grid";
import cn from "classnames";

import styles from "./FieldRow.module.scss";

interface Props {
  isMainRow?: boolean;
  primaryHighLighted: boolean;
  primaryText: React.ReactNode;
  secondaryHighLighted: boolean;
  secondaryText: React.ReactNode;
  title: React.ReactNode;
}

const FieldRow: React.FC<Props> = ({
  isMainRow,
  primaryHighLighted,
  primaryText,
  secondaryHighLighted,
  secondaryText,
  title,
}) => (
  <Row align="middle" className={cn(styles.row, { [styles.headerRow]: isMainRow })}>
    <Col className={styles.primaryCell} span={8}>
      {title}
    </Col>
    <Col className={cn(styles.value, { [styles.highlighted]: primaryHighLighted })} span={8}>
      {primaryText}
    </Col>
    <Col className={cn(styles.value, { [styles.highlighted]: secondaryHighLighted })} span={8}>
      {secondaryText}
    </Col>
  </Row>
);

export default FieldRow;
